import { render, staticRenderFns } from "./warehouse-card.vue?vue&type=template&id=d8f79030"
import script from "./warehouse-card.vue?vue&type=script&lang=js"
export * from "./warehouse-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports